import React from "react";
import HomePageGirlImage from "../../../assets/HomePageGirlImage.png";

export const Hero = () => {
    return (
        <div className="relative bg-gradient-to-b from-secondary-200 to-white pt-32 sm:pt-28 md:pt-40 lg:pt-44  flex flex-col items-center px-4 overflow-hidden">
            {/* ===== TEXT ===== */}
            <div className="absolute text-center top-12 sm:top-16 md:top-20 lg:top-24  z-20 w-full px-4">
                <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold leading-tight">
                    Unlock Your Skills
                </h1>

                <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-primary-800 mt-5 leading-tight">
                    Learn From Real Experts
                </h2>

                <p className="max-w-[90%] sm:max-w-2xl md:max-w-3xl mx-auto  text-zinc-900 mt-4 md:mt-6 text-xs sm:text-sm md:text-base lg:text-lg  leading-relaxed lg:leading-loose  ">
                    Master industry-ready skills through curated courses and hands-on
                    practical projects. Learn with mentorship from experienced instructors
                    who guide you at every step. Build real-world skills and apply them
                    confidently in real industry scenarios.
                </p>
            </div>

            {/* ===== FULL DESIGN IMAGE ===== */}
            <div className="w-full max-w-[1200px] mt-28">
                <img
                    src={HomePageGirlImage}
                    alt="Hero Design"
                    className="w-full h-auto "
                />
            </div>
        </div>
    );
};